import '../../../../node_modules/@blueprintjs/core/dist/blueprint.css';
import './ToastOverrides.scss';
import { Toaster, Intent as BlueprintIntent } from '@blueprintjs/core';

export const GlobalNotifications = Toaster.create({ className: 'dthcIgnoreOnClickOutside' });
export const Intent = BlueprintIntent;



// WEBPACK FOOTER //
// ./webpack/components/Modules/Notifications/Notifications.js